import React from "react";

const comTextarea = ( props,_ref) => {
    const { revInputs,onview,onChangetextareaHandler,textAreHtml } = props;
    return <div className="ta"
                suppressContentEditableWarning={true}
                contentEditable="true"
                onKeyUp={(e) => onview(e)}
                dangerouslySetInnerHTML={ {__html: textAreHtml.revContent}}
                ref = {_ref} ></div>

    /*<p><span contentEditable="false" style={{color : "red"}}>asdasd</span> <span>asdasd</span></p>*/
    /*<textarea className="ta" ref={_ref} onChange={onview} ><p><font>asdasd</font></p></textarea>*/
    /*onChange={onChangetextareaHandler}*/
}

export default React.memo(React.forwardRef(comTextarea));
